import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Resolve a stored object path (e.g. "/objects/<id>") into a URL the browser can
 * load, prefixed with the artifact's base path and the storage serving route.
 */
export function getImageUrl(objectPath: string): string {
  const base = import.meta.env.BASE_URL;
  if (objectPath.startsWith("/objects/")) {
    return `${base}api/storage${objectPath}`;
  }
  return objectPath;
}
